var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layoutToast"},[_c('div',{staticClass:"toastText",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }